export const cfg = {
  selectors: {
    header: '.js-header',
    globalWrapper: '.js-global-wrapper',
    menuMain: '.js-menu-main',
    flyoutContainer: '.js-flyout-container',
    flyout: '.js-flyout',
    flyoutInner: '.js-flyout-inner',
    menuList: '.js-menu-main__list',
    menuListHeader: '.js-main-menu-mobile-header',
    backButton: '.js-menu-main-mobile-level-up',
    menuItem: '.js-menu-main__item',
    menuLink: '.js-menu-main__link',
    menuListOverview: '.js-menu-main__item--overview',
    menuLinkWithChildren: '.js-menu-main__link--has-children',
    menuLinkWithChildrenCss: '.menu-main__link--has-children'
  },
  dataAttrs: {
    linkItemUid: 'data-menu-item-uid',
    menuLevel: 'data-menu-level',
    activeLinkUid: 'data-menu-active-uid'
  },
  breakpoints: {
    mobileMenu: '--breakpoint-mobile-menu'
  },
  classes: {
    active: 'active',
    stopTransitions: 'stop-transitions'
  },
  levelPrefix: '--level-'
};
